export const isAbsoluteUrl = link => (link ? link.startsWith("http") : false)
export const removeTrailingSlash = str => str.replace(/\/$/, "")
